import { fromTimestamp, getDay } from '@/utilities/dateUtils';

export function oddsInputDataFromTimestamp(timestamp: number) {
  const date = fromTimestamp(timestamp);

  return {
    selectedYear: date.get('year'),
    selectedWeek: {
      key: date.get('weekNumber'),
      number: date.get('weekNumber'),
      period: {
        from: getDay(date.startOf('week').toMillis()),
        until: getDay(date.endOf('week').toMillis()),
      },
    },
    selectedDay: timestamp ? getDay(timestamp) : null,
    responseData: {
      days: [],
      weeks: [],
      years: [],
    },
  };
}
